var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLayerFill = function SvgLayerFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5888 11.067L13.3222 16.9117C12.5482 17.545 11.4518 17.545 10.6778 16.9228L3.41117 11.0781C2.86294 10.6337 2.86294 9.76695 3.41117 9.32249L10.6778 3.46669C11.4625 2.84444 12.5482 2.84444 13.3222 3.46669L20.5888 9.31137C21.1371 9.75584 21.1371 10.6225 20.5888 11.067ZM5.06223 14.2972C4.6741 13.9867 4.10773 14.0496 3.79723 14.4378C3.48672 14.8259 3.54965 15.3923 3.93778 15.7028L9.56373 20.2035C10.9881 21.343 13.012 21.343 14.4363 20.2035L20.0622 15.7028C20.4504 15.3923 20.5133 14.8259 20.2028 14.4378C19.8923 14.0496 19.3259 13.9867 18.9378 14.2972L13.3119 18.798C12.5449 19.4115 11.4551 19.4115 10.6882 18.798L5.06223 14.2972Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLayerFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "layer-fill.a9b3d910b68a8c095ad9725d5a7d5538.svg";